import { playSound, Sound } from '~/assets/sounds';
import { IClientConfigs } from '~/shared';
import { BackendService } from '../BackendService';
import { GameConfigService } from '../GameConfigService';
import { INotificationsService } from '../NotificationsService';
import { IRpcService } from '../RpcService';
import { VarsService } from '../VarsService';
import { AbstractDialogueService } from './AbstractDialogueService';

export class DialogueService extends AbstractDialogueService {
	constructor(
		private readonly gameConfig: GameConfigService,
		private readonly backend: BackendService,
		private readonly rpc: IRpcService,
		vars: VarsService,
		notifications: INotificationsService,
	) {
		super(notifications);

		this.onAction('quest_start', async (questId?: string) => {
			await this.backend.invoke('quests:start', { questId });
		});

		this.onAction('quest_finish', async (questId?: string) => {
			await this.backend.invoke('quests:finish', { questId });
		});

		this.onAction('next', async (dialogueId?: string) => {
			if (!dialogueId) {
				console.error(
					`Action "next" requires dialogueId, but got ${dialogueId}`,
				);

				return;
			}

			this.dialogueId.next(dialogueId);
		});

		this.onAction('rpc', async (rpcValue?: string) => {
			if (typeof rpcValue !== 'string') {
				return;
			}

			const idx = rpcValue.indexOf(':');
			const rpcSide = idx === -1 ? rpcValue : rpcValue.slice(0, idx).trim();
			const rpcName = idx === -1 ? '' : rpcValue.slice(idx + 1).trim();
			if (
				(rpcSide !== 'client' && rpcSide !== 'server') ||
				rpcName.length === 0
			) {
				return;
			}

			if (rpcSide === 'client') {
				await this.rpc.invokeClient(rpcName);
			} else if (rpcSide === 'server') {
				await this.rpc.invokeServer(rpcName);
			}
		});

		this.onAction('exit', async () => this.exitMenu());

		vars
			.get('dialogues:npcName', '???')
			.subscribe((newValue) => this.npcName.next(newValue));
		vars
			.get('dialogues:dialogueId', null)
			.subscribe((newValue) => this.dialogueId.next(newValue));

		// @NOTE На бекенде нет такого
		this.backend.addEventHandler('dialogues:complete', () => {
			playSound(Sound.FinalQuest);
		});
	}

	private async exitMenu(): Promise<void> {
		await this.rpc.invokeClient('dialogues:exit');
	}

	protected getConfig(): IClientConfigs['quests']['dialogues'] {
		return this.gameConfig.configs!.quests?.dialogues ?? [];
	}
}
